module.exports = __webpack_public_path__ + "images/500fd4c9e482eabe2b421ef9caca4df2f43cb8675c770941e216007870a1742f.svg";